module.exports = __webpack_public_path__ + "static/media/landingRight-2.dd569d93.webp";